import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CompanyListProvider, EnvironmentListProvider, PageOptions, StructureTotemListProvider } from 'cw-backend';
import { CwUtils, SnackBarService } from 'cw-utils';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'cwg-totem-control',
  templateUrl: './totem-control.component.html',
  styleUrls: ['./totem-control.component.scss']
})
export class TotemControlComponent implements OnInit, OnDestroy {

  loadingPassword: boolean = false;
  showNextPasswords: boolean = false;

  user: any;
  companyTotemSession: any;
  currentPassword: any;
  typeList: any;
  quatityNormal: number = 2;
  quantityNormalCurrent: number = 0;

  environmentControl = new FormControl(null, Validators.required);
  companyControl = new FormControl();
  onlyPriorityControl = new FormControl(false);



  environmentList = new Array<any>();
  companyList = new Array<any>();

  environmentPageOptions = new PageOptions();

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private environmentListProvider: EnvironmentListProvider,
    private companyListProvider: CompanyListProvider,
    private structureTotemListProvider: StructureTotemListProvider,
    private _snackBar: SnackBarService
  ) {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.companyTotemSession = JSON.parse(sessionStorage.getItem("companyTotem"));
    let enviroment = JSON.parse(localStorage.getItem("enviromentTvCall"));
    this.currentPassword = JSON.parse(localStorage.getItem("currentPasswordTotem"));
    this.onlyPriorityControl.setValue(JSON.parse(localStorage.getItem("onlyPriorityControlTotem")));
    if (enviroment?.id) {
      this.environmentControl.setValue(enviroment);
    }
    let qp = this.getParameterPriorityCalls();
    let qpc = this.getParameterPriorityCallsCurrenty();
    this.quatityNormal = CwUtils.checkStringIsNotNull(qp) ? qp : 2;
    this.quantityNormalCurrent = CwUtils.checkStringIsNotNull(String(qpc)) ? Number(qpc) : 0;
  }

  ngOnInit() {
    this.getCompanyList();
    this.observableCompanyControl();
    this.observableonlyPriorityControl();
    if (this.companyTotemSession) {
      this.companyControl.setValue(this.companyTotemSession);
      this.getEnvironmentList();
    } else if
      (this.user?.company) {
      this.getEnvironmentList(this.user.company);
      this.getCompanyId();
    }
  }

  ngOnDestroy() {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  observableCompanyControl() {
    this.companyControl
      .valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (value) => {
          sessionStorage.setItem("companyTotem", JSON.stringify(value));
        }
      })
  }

  observableonlyPriorityControl() {
    this.onlyPriorityControl
      .valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (value) => {
          sessionStorage.setItem("onlyPriorityControlTotem", JSON.stringify(value));
        }
      })
  }


  getCompanyId() {
    this.companyListProvider
      .getTO(this.user.company)
      .then((res: HttpResponse<any>) => {
        this.companyControl.setValue(res.body);
        sessionStorage.setItem("companyTotem", JSON.stringify(res.body));
      });
  }

  getCompanyList() {
    this.companyListProvider
      .getAllUnityList()
      .then((res: HttpResponse<any>) => {
        this.companyList = res.body;
      });
  }


  getEnvironmentList(id?) {
    this.environmentListProvider
      .getPageByCompany(
        id ? id : this.companyControl.value.id,
        this.environmentPageOptions
      )
      .then((res) => {
        this.environmentList = res.content;
      });
  }

  nextPassword() {

    if (!this.environmentControl.value?.id) {
      this._snackBar.warnMessage("Selecione um local para chamada.");
      this.environmentControl.markAllAsTouched();
      return;
    }

    if (this.loadingPassword == true) {
      return;
    }
    this.loadingPassword = true;

    let typePassword = "N";

    if (this.quantityNormalCurrent == this.quatityNormal) {
      typePassword = "P";
      this.quantityNormalCurrent = 0;
      sessionStorage.setItem("normalCallsBeforePriorityCurrenty", JSON.stringify(this.quantityNormalCurrent));
    } else {
      this.quantityNormalCurrent = this.quantityNormalCurrent + 1;
      sessionStorage.setItem("normalCallsBeforePriorityCurrenty", JSON.stringify(this.quantityNormalCurrent));
    }

    if (this.onlyPriorityControl.value) {
      typePassword = "P";
    }

    this.structureTotemListProvider
      .getNextPassword(this.companyControl.value.id, this.environmentControl.value.id, typePassword)
      .then((res: HttpResponse<any>) => {
        if (res.body.code == "WARN") {
          this._snackBar.warnMessage("Não há senhas disponíveis para chamada.");
          this.loadingPassword = false;
          this.quantityNormalCurrent = 0;
          sessionStorage.setItem("normalCallsBeforePriorityCurrenty", JSON.stringify(this.quantityNormalCurrent));
          return;
        }
        if (typePassword == "P" && res.body.data.patientStatus == "N") {
          this.quantityNormalCurrent = this.quantityNormalCurrent - 1;
          sessionStorage.setItem("normalCallsBeforePriorityCurrenty", JSON.stringify(this.quantityNormalCurrent));
        }
        this.callPassword(res.body.data);
        this.loadingPassword = false;
      }).catch((error) => {
        this.loadingPassword = false;
      });
  }

  callPassword(password) {
    this.currentPassword = password;
    localStorage.setItem("currentPasswordTotem", JSON.stringify(this.currentPassword));
  }

  listPasswords(type: string) {
    if (!this.environmentControl.value?.id) {
      this._snackBar.warnMessage("Selecione um local para chamada.");
      this.environmentControl.markAllAsTouched();
      return;
    }
    this.typeList = type;
    this.showNextPasswords = true;
  }

  finishPassword() {
    this.currentPassword = null;
    localStorage.removeItem("currentPasswordTotem");
  }

  oCallPassword(password) {
    this.showNextPasswords = false
    this.callPassword(password);
  }

  setEnviroment(environment) {
    localStorage.setItem("enviromentTvCall", JSON.stringify(environment));
  }

  getParameterPriorityCalls() {
    return JSON.parse(localStorage.getItem("system_params"))
      .find(param => param.name == "NORMAL_CALLS_BEFORE_PRIORITY")?.value;
  }

  getParameterPriorityCallsCurrenty() {
    return JSON.parse(sessionStorage.getItem("normalCallsBeforePriorityCurrenty"));
  }

  displaySimpleFn(object?: any): string | undefined {
    if (object && object.id) {
      return object.name;
    } else {
      return "";
    }
  }

  compareSelect(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return null;
    }
    return o1.id === o2.id;
  }

}
